import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { DevelopmentFeaturedComponent } from '@core/layout/components/featured/featured.component';
import { LeadsDialogModule } from '@core/layout/components/leads-dialog/leads-dialog.module';
import { ButtonDefaultModule } from '@core/layout/components/material/buttons/default/default.module';

import { SharedModule } from '@shared/shared.module';

@NgModule({
  declarations: [DevelopmentFeaturedComponent],
  imports: [
    CommonModule,
    RouterModule,
    FlexLayoutModule,
    MatProgressSpinnerModule,
    TranslateModule.forChild(),
    SharedModule,
    MatDialogModule,
    LeadsDialogModule,
    ButtonDefaultModule,
  ],
  exports: [DevelopmentFeaturedComponent],
})
export class DevelopmentFeaturedModule {}
